var Chartist = require("chartist");
 
var delays = 80,
  durations = 500; 

export const makeScatterData = (arr,bool) => {
  return {
    data: {
      labels: Object.keys(arr),
      series: [Object.values(arr)]
    },
    options: {
      lineSmooth: Chartist.Interpolation.cardinal({
        tension: 0
      }),
      low: 0,
      high: Math.max(...Object.values(arr)) + (Math.max(...Object.values(arr)) * 0.5) , // alder: we recommend you to set the high sa the biggest value + something for a better look
      chartPadding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }, 
      axisY: {
        labelInterpolationFnc: function(value) {
          if(bool)
            return value / 1000 + "K"
          else
            return value
    		}
      }, 
    },
    // for animation
    animation: {
      draw: function(data) {
        if (data.type === "line" || data.type === "area") {
          data.element.animate({
            d: {
              begin: 600,
              dur: 700,
              from: data.path
                .clone()
                .scale(1, 0)
                .translate(0, data.chartRect.height())
                .stringify(),
              to: data.path.clone().stringify(),
              easing: Chartist.Svg.Easing.easeOutQuint
            }
          });
        } else if (data.type === "point") {
          data.element.animate({
            opacity: {
              begin: (data.index + 1) * delays,
              dur: durations,
              from: 0,
              to: 1,
              easing: "ease"
            }
          });
        }
      }
    }
  };
}

 
